<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OKYoH1/tc-custom/9781480461741.jpg?1704278398611" alt="This image is the cover for the book Neveryóna, Return to Nevèrÿon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neveryóna, Return to Nevèrÿon
      </h1>
      <p class="bookDescription body article font2">
        <b>The Hugo and Nebula Award–winning author of <i>Tales of Nevèrÿon</i> “continues to surprise and delight” with this thought-provoking epic fantasy (<i>The New York Times</i>).</b><br/>  One of the few in Nevèrÿon who can read and write, pryn has saddled a wild dragon and taken off from a mountain ledge. Self-described as an adventurer, warrior, and thief, in her journey pryn will meet plotting merchants, sinister aristocrats, half-mad villagers, and a storyteller who claims to have invented writing itself. The land of Nevèrÿon is mired in a civil war over slavery, and pryn will also find herself—for a while—fighting alongside Gorgik the Liberator, from whom she will learn the cunning she needs as she journeys further and further south in search of a sunken city; for at history’s dawn, some dangers even dragons cannot protect you from.<br/> The second volume in Samuel R. Delany’s Return to Nevèrÿon cycle, <i>Neveryóna </i>is the longer of its two full-length novels. (The other is <i>The Tale of Plagues and Carnivals</i>.) An intriguing meditation on the power of language, the rise of cities, and the dawn of myth, markets, and money, it is a truly wonder-filled adventure.<br/><i>This ebook features an illustrated biography of Samuel R. Delany including rare images from his early career.</i> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Samuel R. Delany
      </h2>
      
      <p class="authorDescription body article">Samuel R. Delany published his first novel, <I>The Jewels of Aptor</I>, at the age of twenty. Throughout his storied career, he has received four Nebula Awards and two Hugo Awards, and in 2008 his novel <I>Dark Reflections</I> won the Stonewall Book Award. He was inducted into the Science Fiction and Fantasy Hall of Fame in 2002, named a Grand Master by the Science Fiction Writers of America in 2014, and in 2016 was inducted into the New York State Writers Hall of Fame. Delany&rsquo;s works also extend into memoir, criticism, and essays on sexuality and society. After many years as a professor of English and creative writing and director of the graduate creative writing program at Temple University, he retired from teaching in 2015. He lives in Philadelphia with his partner, Dennis Rickett.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?894c7c76